<template>
    <el-drawer
        title="新增/编辑话题"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="name" label="话题名称:">
                    <el-input v-model="formData.name" placeholder="请输入话题名称" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item prop="cover" label="话题封面:">
                    <image-upload 
                        :url.sync="formData.cover" 
                        :urlFull.sync="formData.cover" 
                    >
                    </image-upload>
                </el-form-item>
                <el-form-item prop="desc" label="话题简介:">
                    <el-input v-model="formData.desc" placeholder="请输入话题简介" maxlength="200" type="textarea" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="status" label="使用状态:">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="1" border>启用</el-radio>
                        <el-radio :label="0" border>禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
import ImageUpload from "@/components/ImageUpload";
const defaultData = {
    name: "",
    cover: "",
    desc: "",
    status: 1
}
export default {
    components:{
        ImageUpload
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                ...defaultData
            },
            
            rules:{
                name:[{ required: true, message: "请填写话题名称" }]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(id){
            if( id ){
                this.formData.id = id;
                this.getData();
            }
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/topic/info',
                params: {topicId: this.formData.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });  
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/topic/save',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>